/** Koraci čarobnjaka, redom. Redoslijed odgovara `stepNumber` u `WizardStep`. */
export const PRICING_STEP_LABELS: string[] = [
  "Osnovno",
  "Cijena po vozilu",
  "Cjenovni razredi",
  "Mjereni troškovi",
  "Ostale vrijednosti",
];

/** Prvi korak nosi datum važenja i mora se proći prije skakanja po sekcijama. */
export const PRICING_MANDATORY_STEP_COUNT = 1;
